import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';


const MsgTmplAdminNewView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [objAttrs, setObjAttrs] = useState({
    id: '',
    name: '',
    description: '',
    type: '',
    language: '',
    subject: '',
    body: '',
    updatedBy: '',
    timeUpdated: '',
    createdBy: '',
    timeCreated: ''
  });

  const [languageList, ] = useState([
    { key: "en",    value: "en" },
    { key: "zh_HK", value: "zh_HK" },
    { key: "zh_CN", value: "zh_CN" }
  ]);

  const [typeList, ] = useState([
    { key: "EMAIL_TMPL", value: "EMAIL_TMPL" },
    { key: "SMS_TMPL",   value: "SMS_TMPL" }
  ]);


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setObjAttrs({ ...objAttrs, [e.target.name]: e.target.value })
  }

  const onLanguageSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, language: key })
  };

  const onTypeSelect = (key, event) => {
    setObjAttrs({ ...objAttrs, type: key })
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form inputs
    if (objAttrs.name.length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if ((objAttrs.name != null) && (objAttrs.name.length > 100)) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);

    } else if (objAttrs.description === '') {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if ((objAttrs.description != null) && (objAttrs.description.length > 250)) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 250);

    } else if (objAttrs.language === '') {
      setErrMsg(t("I18N_ERR_Need_language"));
    } else if ((objAttrs.language != null) && (objAttrs.type.language > 10)) {
      setErrMsg(t("I18N_ERR_Max_len_lang") + 10);

    } else if (objAttrs.type === '') {
      setErrMsg(t("I18N_ERR_Need_type"));
    } else if ((objAttrs.type != null) && (objAttrs.type.length > 20)) {
      setErrMsg(t("I18N_ERR_Max_len_type") + 20);

    } else if (objAttrs.subject === '') {
      setErrMsg(t("I18N_ERR_Need_subject"));
    } else if ((objAttrs.subject != null) && (objAttrs.subject.length > 200)) {
      setErrMsg(t("I18N_ERR_Max_len_subject") + 200);

    } else if (objAttrs.body === '') {
      setErrMsg(t("I18N_ERR_Need_body"));
    } else if ((objAttrs.body != null) && (objAttrs.body.length > 2000)) {
      setErrMsg(t("I18N_ERR_Max_len_body") + 2000);

    } else {
      setErrMsg('');
      createNewObj();
    }
  }

  const createNewObj = () => {

    // Make a deep copy
    let reqBody = JSON.parse(JSON.stringify(objAttrs));

    reqBody.name    = objAttrs.name + '_' + objAttrs.language;
    reqBody.subject = encodeURIComponent(objAttrs.subject);
    reqBody.body    = encodeURIComponent(objAttrs.body);

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_PLATFORM_API.post("msg-templates", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          navigate(-1);
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Msg_Tmpl")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_MsgTmpl_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <Row className={classes.admin_pages__field_label}>
            <Col>{t("I18N_Name")}: *</Col>
            <Col>{t("I18N_Language")}: *</Col>
            <Col>{t("I18N_Description")}: *</Col>
            <Col>{t("I18N_Type")}: *</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col>
              <input className={classes.admin_pages__field_editable} name="name" value={objAttrs.name} style={{width:'100%'}}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col>
              <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                title={(objAttrs.language === "") ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_Lng_" + objAttrs.language)}
                onSelect={onLanguageSelect}>
                {languageList.map((item, index) => {
                  return (
                    <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                      {t("I18N_Lng_" + item.value)}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </Col>
            <Col>
              <textarea className={classes.admin_pages__field_editable} name="description" value={objAttrs.description}
                        style={{width:'100%'}}
                        onChange={(e) => onAttrsInputChange(e)} />
            </Col>
            <Col>
              <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                title={(objAttrs.type === "") ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + objAttrs.type)}
                onSelect={onTypeSelect}>
                {typeList.map((item, index) => {
                  return (
                    <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                      {t("I18N_" + item.value)}
                    </Dropdown.Item>
                  );
                })}
              </DropdownButton>
            </Col>
          </Row>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            <Col>{t("I18N_Subject")}: *</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col>
              <textarea className={classes.admin_pages__field_editable} name="subject" value={objAttrs.subject}
                rows={1} style={{width:'100%', fontFamily:'Courier New'}}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
          </Row>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
            <Col>{t("I18N_Body")}: *</Col>
          </Row>
          <Row className={classes.admin_pages__field_value}>
            <Col>
              <textarea className={classes.admin_pages__field_editable} name="body" value={objAttrs.body}
                rows={18} style={{width:'100%', fontFamily:'Courier New'}}
                onChange={(e) => onAttrsInputChange(e)} />
            </Col>
          </Row>

          <hr className="solid" style={{ marginTop: '30px' }}></hr>

          <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
            <span>{t("I18N_Req_fields")}</span>
          </Row>

          <Row>
            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleCancel}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleSubmit}>
                {t("I18N_Submit")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {errMsg}
              </span>
            </div>
          </Row>
        </Container>

      </Card>
    </>
  );
}

export default MsgTmplAdminNewView;
